import { render } from "./FinalPricePanel.vue?vue&type=template&id=42be51e9&scoped=true&ts=true"
import script from "./FinalPricePanel.vue?vue&type=script&lang=ts"
export * from "./FinalPricePanel.vue?vue&type=script&lang=ts"

import "./FinalPricePanel.vue?vue&type=style&index=0&id=42be51e9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42be51e9"]])

export default __exports__